import React, { useState, useEffect } from "react";
import "Resources/Css/bootstrap.min.css";
import "Resources/Css/StyleSheet.css";
import "Resources/Css/css.css";
import "Resources/Css/cssNew1.css";
import "Resources/Css/MaterialDesign-Webfont-master/css/materialdesignicons.min.css";
import "Resources/Css/css1.css";
import "react-widgets/dist/css/react-widgets.css";

import main_right from "Resources/ImagesNew/right.png";
import facebookIcon from "Resources/ImagesNew/facebookIcon.png";
import zaloIcon from "Resources/ImagesNew/zaloIcon.png";
import carbon_phoneIcon from "Resources/ImagesNew/carbon_phone-voice-filled.png";
import quill_eye from "Resources/ImagesNew/quill_eye.png";
import clarity_eye from "Resources/ImagesNew/clarity_eye-hide-line.png";
import { getDomain } from "utils/utils";
import { Cookies } from "react-cookie";

export const DangNhap = () => {
  document.title = "Đăng nhập hệ thống đại lý";
  //const dispatch = useDispatch();
  //const danhmuc = useSelector((state) => state.danhmuc);
  //const { objConfigAll } = danhmuc;
  const cookies = new Cookies();
  // cookies.remove("userTokenDaiLy", { path: "/" });
  // cookies.remove("userDaiLy", { path: "/" });
  useEffect(() => {}, []);

  useEffect(() => {
    // dispatch(Index_GetConfigAllSTKey());
  }, []);

  const [taikhoan, setTaiKhoan] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [Version2, setVersion2] = useState(false);
  // const [isDailyDatHangVersion2, setIsDailyDatHangVersion2] = useState(false);
  // const [isCheckDailyDatHangVersion2, setIsCheckDailyDatHangVersion2] =
  //   useState(false);

  // if (objConfigAll.List.length > 0 && isCheckDailyDatHangVersion2 === false) {
  //   const configDailyDatHangVersion2 = objConfigAll.List.find(
  //     (e) =>
  //       e.KeyID.toUpperCase() ===
  //       configs.sKey.DAILY_DATHANG_VERSION2.toUpperCase(),
  //   );

  //   setIsDailyDatHangVersion2(false);

  //   if (
  //     typeof configDailyDatHangVersion2 !== "undefined" &&
  //     configDailyDatHangVersion2 != null &&
  //     configDailyDatHangVersion2.Value
  //   ) {
  //     if (configDailyDatHangVersion2.Value === "1") {
  //       setIsDailyDatHangVersion2(true);
  //     }
  //   }

  //   setIsCheckDailyDatHangVersion2(true);
  // }

  const handleLogin = () => {
    if (taikhoan.trim() == "") {
      setError("Nhập tài khoản đăng nhập.");
      return;
    }
    if (password.trim() == "") {
      setError("Nhập mật khẩu đăng nhập.");
      return;
    }

    setError("");
    setLoading(true);

    fetch(
      getDomain() +
        "dangnhap/dologin?taikhoan=" +
        taikhoan +
        "&matkhau=" +
        password,
      {},
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("datadata", data);
        if (data.Error == 200) {
          debugger;
          if (data.ToKen != "") {
            cookies.set("userTokenDaiLy", data.ToKen, { path: "/" });
            cookies.set("userDaiLy", taikhoan + "|" + data.TenDaiLy, {
              path: "/",
            });
            setVersion2(data.Version2);
            if (data.Version2 == true) {
              window.location.href = "/DatHangDaiLy";
            } else {
              window.location.href = "/";
            }
          } else {
            setError("Hệ thống xảy ra lỗi. Vui lòng thử lại sau.");
          }
        } else {
          setError(data.Message);
        }
      });

    setLoading(false);
  };

  const onChangeTaiKhoan = (field, event) => {
    setTaiKhoan(event.target.value);
  };

  const onChangeMatKhau = (field, event) => {
    setPassword(event.target.value);
  };

  const [showPass, setShowPass] = useState(false);

  const handleTaoDon = () => {
    window.location.href = "/DatHangNgoai";
  };

  return (
    <>
      <div class="d-lg-flex half form-des-ver2">
        <div
          class="bg order-2 order-md-2"
          style={{ backgroundImage: "url('" + main_right + "')" }}
        ></div>
        <div class="contents order-1 order-md-1 bg-login-ver2">
          <div class="container">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-6">
                <div class="form-login-ver2">
                  <h3 class="login-title">Đại Lý Đăng nhập</h3>

                  <div class="form-group first">
                    <label for="username">
                      Tài khoản <span style={{ color: "#F24E1E" }}>*</span>
                    </label>
                    <input
                      class="form-control"
                      type="text"
                      id="txtUserName"
                      placeholder="Tài khoản đăng nhập"
                      onChange={(e) => onChangeTaiKhoan("txtUserName", e)}
                    />
                  </div>

                  <div class="last  login-ver2">
                    <label for="password">
                      Mật khẩu <span style={{ color: "#F24E1E" }}>*</span>
                    </label>
                    <input
                      class="form-control"
                      type={showPass ? "text" : "password"}
                      id="txtPassword"
                      placeholder="Mật khẩu đăng nhập"
                      autoComplete="current-password"
                      onChange={(e) => onChangeMatKhau("txtPassword", e)}
                    />
                    <div class="input-group-append">
                      <div onClick={() => setShowPass(!showPass)}>
                        {showPass == false ? (
                          <>
                            <span id="show_eye" class="toggleShowHide">
                              <img src={quill_eye} alt="" />
                            </span>
                          </>
                        ) : (
                          <>
                            <span id="hide_eye" class="toggleShowHide">
                              <img src={clarity_eye} alt="" />
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class=" text-right-main bottom-form-button">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="RememberMe"
                        id="RememberMe"
                        style={{ width: "14px" }}
                      />
                      <label
                        class="form-check-label"
                        for="RememberMe"
                        style={{ marginTop: "0px" }}
                      >
                        Nhớ mật khẩu
                      </label>
                    </div>
                  </div>

                  {error !== "" && (
                    <>
                      <span style={{ color: "red" }}>{error}</span>
                    </>
                  )}

                  <button
                    class="button-login bg-blue-main"
                    onClick={handleLogin}
                    disabled={loading}
                  >
                    Đăng nhập
                  </button>
                  {/* <>
                  {!isDailyDatHangVersion2 && (
                    <button
                      class="button-login bg-Orange-main"
                      onClick={handleTaoDon}
                      disabled={loading}
                      style={{
                        marginTop: "25px",
                        marginLeft: "0px",
                        fontWeight: "bold",
                      }}
                    >
                      Đặt hàng không cần đăng nhập
                    </button>
                  )}
</> */}
                  <div class="footer-login">
                    <div class="form-support">
                      <h3 class="title-support">Tổng đài hỗ trợ:</h3>

                      <div class="nav-item-new text-phone-new">
                        <img src={carbon_phoneIcon} alt="" />
                        <a href="tel:0328666932" alt="">
                          <span>0328 666 932</span>
                        </a>
                      </div>

                      <div class="nav-item-new">
                        <a
                          href="https://www.facebook.com/groups/PhanmembanhangNiemTin"
                          alt=""
                        >
                          <img src={facebookIcon} alt="" />
                        </a>
                      </div>

                      <div class="nav-item-new">
                        <a href="http://zalo.me/sdtzalo" alt="">
                          <img src={zaloIcon} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="text-footer-login">
                    Copyright 2010 Niemtin Company. All Rights Reserved
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
